import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const ForgotPassword = ({
  text,
  className,
  style,
  version,
  disabled,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    ...props,
    style,
    className: cx(styles.box, className, {
      [styles[version || ""]]: !!version,
      [styles.disabled]: !!disabled
    })
  },
  text
);
ForgotPassword.displayName = "Auth.Form.ForgotPassword";

export { ForgotPassword };
//# sourceMappingURL=index.js.map
